import { render } from "./Tier.vue?vue&type=template&id=777f7de7&scoped=true"
import script from "./Tier.vue?vue&type=script&lang=ts"
export * from "./Tier.vue?vue&type=script&lang=ts"

import "./Tier.vue?vue&type=style&index=0&id=777f7de7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-777f7de7"

export default script